import { render } from "./ArticleDetails.vue?vue&type=template&id=47562d1b&scoped=true"
import script from "./ArticleDetails.vue?vue&type=script&lang=js"
export * from "./ArticleDetails.vue?vue&type=script&lang=js"

import "./ArticleDetails.vue?vue&type=style&index=0&id=47562d1b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/Source Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47562d1b"]])

export default __exports__